import React, { useState } from "react";

import { Typography, Box, Button, TextField } from "@mui/material";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import { PlanDropDown, Switch } from "../../../common";
import { updatePost as updatePostAction } from "../../../redux/slices/postsSlice";
import { RESUME_APP_URL } from "../../../config/secrets";

const ShareLink = ({ post }) => {
  const { postId } = useParams();
  const [activeResource, setActiveResource] = useState(false);
  const [copied, setCopied] = useState(false);
  const [expiresIn, setExpiredIn] = useState("1 week");

  const onCopy = () => {
    const urlToCopy = post?.job_post_url
      ? post.job_post_url
      : `${RESUME_APP_URL}/?postId=${postId}`;

    setCopied(true);
    navigator.clipboard.writeText(urlToCopy);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box display="flex" borderRadius="10px" height="100%" gap={2}>
      <Box
        bgcolor="#FAFAFA"
        flex={1}
        mx="auto"
        p={4}
        borderRadius="20px"
        gap={2}
      >
        <Typography
          textAlign="left"
          fontSize="15px"
          fontWeight={700}
          fontFamily="Outfit"
        >
          Post link
        </Typography>
        <Box
          width="100%"
          mt={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <TextField
            value={
              post?.job_post_url
                ? post.job_post_url
                : `${RESUME_APP_URL}/?postId=${postId}`
            }
            contentEditable={false}
            focused={false}
            sx={{
              flexBasis: "80%",
              flexGrow: 0,
              color: "#999",
              fontFamily: "Outfit",
            }}
            inputProps={{
              readOnly: true,
            }}
          />
          <Button
            variant="main"
            sx={{
              py: 1.5,
              flexBasis: "20%",
              flexGrow: 0,
              flexShrink: 0,
              px: 0,
              fontFamily: "Outfit",
            }}
            onClick={onCopy}
          >
            {copied ? "Link copied" : "Copy link"}
          </Button>
        </Box>

        <Box mt={2}>
          <Typography
            textAlign="left"
            fontSize="15px"
            fontWeight={700}
            fontFamily="Outfit"
          >
            Info
          </Typography>
          <Typography
            fontSize="14px"
            color="#5B6F82"
            my={2}
            fontFamily="Outfit"
          >
            {
              "Use the 'Copy Link' feature to easily share this job opportunity with potential candidates. Anyone with the link can view the job details and apply directly."
            }
          </Typography>
          <Typography fontSize="14px" color="#5B6F82" fontFamily="Outfit">
            {
              "We recommend sharing the link with suitable candidates to ensure it reaches the right talent and provides a smooth application experience for all."
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const mapDipatchToProps = {
  updatePost: updatePostAction,
};

export default connect(null, mapDipatchToProps)(ShareLink);
